<template>
  <div>
    <div class="order-content" v-if="orders.length>=0">
      <div class="content" v-for="(product,i) in orders" :key="i">
        <!--        订单明明细-->
        <table style="text-align: left;background-color: rgb(254,254,254);">
          <tbody style="border: 1px #e5e7e8 solid;">
          <tr style="background-color: rgb(240,240,240);">
            <td style="display: flex">
              <span style="margin-left: 10px;font-weight: bold;margin-top: 3px">{{product.orderTime}}</span>
              <span style="margin-left: 10px">订单号 : {{product.orderId}}</span>
            </td>
            <td style="width: 25%">
              <span style="margin-left: 30px"> 生效时间 : {{product.userBalance.effDate}} </span>
            </td>
            <td >
              <span style="margin-left: 30px"> 失效时间 : {{product.userBalance.expDate}}</span>
            </td>
          </tr>
          <tr style="background-color: rgb(254,254,254);">
            <td style="display: flex;margin-left: 10px">
              <img :src="$target +product.productDetails.image" style="width: 8.625rem;height: 4.625rem;">
              <div style="padding-left: 1.25rem;line-height: 3.25rem;">
                <p>{{product.productDetails.offerName}}</p>
              </div>
            </td>
            <td style="border-right: 1px #e5e7e8 solid;border-left: 1px #e5e7e8 solid ;">
              <span v-if="product.isChannel !== 4">
                支付方式 : <span>{{product.isChannel===0?"未支付":product.isChannel===2?"微信":"支付宝"}}</span><br>
              <span v-if="product.deductionPrice !== 0" style="color: #6a737d;text-decoration: line-through red">  ￥{{((product.productDetails.price)/100).toFixed(2)}}</span><br>
              <span v-if="product.paid === '1'"> ￥{{(product.payPrice/100).toFixed(2)}}</span><br />
              </span>
              <span v-if="product.isChannel === 4">
                支付方式 : <span>赠送</span><br>
              </span>



            </td>
            <td>
              <span> 剩余次数 : {{product.userBalance.usageBalance }}</span><br />
              <span style="color: #0C75EA;cursor:pointer " @click="goOrderProduct(product)"> 使用明细</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- 我的订单主要内容END -->

    <!-- 订单为空的时候显示的内容 -->
    <div v-else class="order-empty">
      <div class="empty">
        <h2>您的订单还是空的！</h2>
<!--        <p>快去购物吧！</p>-->
      </div>
    </div>
  </div>
</template>

<script>
import {
  orderlist
} from "@/api/orderApi"

export default {
  name: 'MyOrder',
  data() {
    return {
      orders: [], // 订单列表
      total: [] // 每个订单的商品数量及总价列表
    };
  },
  created() {
    // 获取订单数据
    orderlist().then((res) => {
      res.rows.forEach(item => {
        item.productDetails = JSON.parse(item.productDetails)
        item.userBalance =  JSON.parse(item.userBalance)
      })
      this.orders = res.rows
    })
  },
  methods: {
    goOrderProduct(product) {
      localStorage.setItem("balance", JSON.stringify(product.userBalance.balanceId))
      this.$router.push({
        path: "/OrderDetails",
      });
    },
  },
}
</script>

<style scoped>
.order-content{
  padding-bottom: 5px;
  font-size: 14px;
  color: #606266;
}

.content {
  padding-bottom: 1%;
}

table{
  width: 100%;
  border-collapse: collapse;
  border-radius: 20px;
}

td{
  //border: 1px solid #eaf8ff;
  text-align: center;
  padding: 6px 0;
}

table thead tr{
  background-color: #ccc;
}

 table:hover tbody{
  border: 1px skyblue solid !important;
}

</style>